import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "acs" }
const _hoisted_2 = {
  class: "acs__kpis",
  "data-tour": "admin-cs-kpis"
}
const _hoisted_3 = { class: "acs__kpi-value" }
const _hoisted_4 = { class: "acs__kpi-value" }
const _hoisted_5 = { class: "acs__kpi-value" }
const _hoisted_6 = { class: "sui-card acs__kpi" }
const _hoisted_7 = { class: "acs__kpi-value" }
const _hoisted_8 = {
  class: "sui-card sui-card--flush",
  "data-tour": "admin-cs-list"
}
const _hoisted_9 = {
  class: "sui-tabs",
  "data-tour": "admin-cs-tabs"
}
const _hoisted_10 = {
  class: "sui-toolbar",
  "data-tour": "admin-cs-toolbar"
}
const _hoisted_11 = {
  class: "acs__channel-tabs",
  "data-tour": "admin-cs-channel",
  role: "tablist",
  "aria-label": "상담 채널"
}
const _hoisted_12 = ["aria-selected"]
const _hoisted_13 = ["aria-selected"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["aria-selected"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "acs__select" }
const _hoisted_18 = { class: "sui-search" }
const _hoisted_19 = { class: "sui-check" }
const _hoisted_20 = { class: "sui-search" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "acs__error"
}
const _hoisted_24 = {
  key: 1,
  class: "acs__toast"
}
const _hoisted_25 = {
  key: 2,
  class: "sui-table-wrap"
}
const _hoisted_26 = { class: "sui-table" }
const _hoisted_27 = { class: "acs__status-cell" }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "sui-table__sub" }
const _hoisted_30 = { class: "sui-table__strong" }
const _hoisted_31 = { class: "acs__body" }
const _hoisted_32 = {
  key: 0,
  class: "acs__channel-badge is-test"
}
const _hoisted_33 = { class: "acs__order-badge-code" }
const _hoisted_34 = {
  key: 1,
  class: "acs__order-badge acs__order-badge--none"
}
const _hoisted_35 = { class: "sui-table__sub" }
const _hoisted_36 = { class: "is-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "acs__pager"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 3,
  class: "sui-table-wrap"
}
const _hoisted_42 = { class: "sui-table" }
const _hoisted_43 = { class: "sui-table__sub" }
const _hoisted_44 = { class: "sui-table__strong" }
const _hoisted_45 = { class: "sui-table__sub" }
const _hoisted_46 = { class: "sui-table__sub" }
const _hoisted_47 = { class: "acs__order-badge-code" }
const _hoisted_48 = {
  key: 1,
  class: "acs__order-badge acs__order-badge--none"
}
const _hoisted_49 = {
  key: 2,
  class: "sui-table__sub"
}
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "acs__body" }
const _hoisted_52 = {
  key: 0,
  class: "sui-table__sub acs__reply"
}
const _hoisted_53 = { class: "is-center" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = {
  key: 4,
  class: "sui-table-wrap"
}
const _hoisted_58 = { class: "sui-table" }
const _hoisted_59 = { class: "sui-table__sub" }
const _hoisted_60 = { class: "sui-table__strong" }
const _hoisted_61 = { class: "sui-table__sub" }
const _hoisted_62 = { class: "sui-table__sub" }
const _hoisted_63 = { class: "acs__order-badge-code" }
const _hoisted_64 = {
  key: 1,
  class: "acs__order-badge acs__order-badge--none",
  title: "이 후기에 연결된 주문이 없습니다."
}
const _hoisted_65 = {
  key: 2,
  class: "sui-table__sub"
}
const _hoisted_66 = ["title"]
const _hoisted_67 = { class: "acs__body" }
const _hoisted_68 = {
  key: 0,
  class: "sui-table__sub acs__reply"
}
const _hoisted_69 = { class: "is-center" }
const _hoisted_70 = ["href"]
const _hoisted_71 = ["disabled", "onClick"]
const _hoisted_72 = {
  key: 5,
  class: "sui-empty"
}
const _hoisted_73 = { class: "acs__panel" }
const _hoisted_74 = { class: "acs__panel-head" }
const _hoisted_75 = { class: "acs__panel-body" }
const _hoisted_76 = { class: "acs__meta" }
const _hoisted_77 = {
  key: 0,
  class: "acs__channel-badge is-test"
}
const _hoisted_78 = { class: "acs__order-badge-code" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "acs__block" }
const _hoisted_81 = { class: "acs__block-text" }
const _hoisted_82 = {
  key: 0,
  class: "acs__block"
}
const _hoisted_83 = ["disabled"]
const _hoisted_84 = {
  class: "acs__block acs__delegate",
  "data-tour": "admin-cs-consult-delegate"
}
const _hoisted_85 = { class: "acs__delegate-hint" }
const _hoisted_86 = { class: "acs__delegate-row" }
const _hoisted_87 = { class: "acs__switch" }
const _hoisted_88 = ["checked", "disabled"]
const _hoisted_89 = { class: "acs__switch-label" }
const _hoisted_90 = {
  key: 0,
  class: "acs__delegate-status"
}
const _hoisted_91 = {
  key: 1,
  class: "acs__delegate-status"
}
const _hoisted_92 = {
  key: 1,
  class: "acs__block"
}
const _hoisted_93 = ["disabled", "onClick"]
const _hoisted_94 = {
  class: "acs__block",
  "data-tour": "admin-cs-consult-reply"
}
const _hoisted_95 = {
  class: "acs__suggest",
  "data-tour": "admin-cs-consult-suggest"
}
const _hoisted_96 = { class: "acs__suggest-head" }
const _hoisted_97 = { class: "acs__suggest-label" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = {
  key: 0,
  class: "acs__suggest-hint"
}
const _hoisted_100 = {
  key: 1,
  class: "acs__suggest-hint"
}
const _hoisted_101 = ["onClick"]
const _hoisted_102 = { class: "acs__file" }
const _hoisted_103 = {
  key: 0,
  class: "acs__file-name"
}
const _hoisted_104 = { class: "acs__panel-foot" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { class: "acs__panel" }
const _hoisted_107 = { class: "acs__panel-head" }
const _hoisted_108 = { class: "acs__panel-body" }
const _hoisted_109 = { class: "acs__meta" }
const _hoisted_110 = { class: "acs__block" }
const _hoisted_111 = { class: "acs__block-text" }
const _hoisted_112 = { class: "acs__block" }
const _hoisted_113 = {
  key: 0,
  class: "acs__error"
}
const _hoisted_114 = { class: "acs__panel-foot" }
const _hoisted_115 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  answerAdminCsQna,
  createAdminConsultResponse,
  deleteAdminCsItem,
  downloadAdminConsultExcel,
  downloadAdminConsultResponseExcel,
  fetchAdminConsultAiReplies,
  fetchAdminConsultDetail,
  fetchAdminConsultList,
  fetchAdminCs,
  setAdminConsultSellerReplyPermission,
  type AdminConsultDetail,
  type AdminConsultListItem,
  type AdminConsultResponse,
  type AdminCsQna,
  type AdminCsReview,
} from '@/api/admin'

type CsTab = 'consult' | 'qna' | 'review'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCsPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

function initialTab(): CsTab {
  const raw = String(route.query.tab || '')
  if (raw === 'qna' || raw === 'review' || raw === 'consult') return raw
  return 'consult'
}

const tab = ref<CsTab>(initialTab())
const unansweredOnly = ref(route.query.unanswered === '1')
const keyword = ref(String(route.query.keyword || ''))
const consultStatus = ref(String(route.query.status || ''))
const consultChannel = ref(String(route.query.channel || '').toUpperCase() === 'MALL' ? 'MALL' : String(route.query.channel || '').toUpperCase() === 'PORTAL' ? 'PORTAL' : '')
const qnas = ref<AdminCsQna[]>([])
const reviews = ref<AdminCsReview[]>([])
const consultItems = ref<AdminConsultListItem[]>([])
const consultPagination = ref({ page: 1, limit: 20, total: 0, totalPages: 1 })
const unansweredQna = ref(0)
const unansweredReview = ref(0)
const unansweredConsult = ref(0)
const unansweredConsultPortal = ref(0)
const unansweredConsultMall = ref(0)
const loading = ref(false)
const working = ref('')
const errorMessage = ref('')
const toast = ref('')
let toastTimer: ReturnType<typeof setTimeout> | undefined

const replySuggestions = ref<string[]>([])
const aiSuggestLoading = ref(false)
const aiSuggestSource = ref<'ai' | 'fallback' | ''>('')
const aiSuggestHint = ref('')
let aiSuggestSeq = 0

const consultDetail = ref<AdminConsultDetail | null>(null)
const replyContent = ref('')
const replyExcelFile = ref<File | null>(null)
const replyExcelInput = ref<HTMLInputElement | null>(null)
const submittingReply = ref(false)
const delegateSaving = ref(false)
const downloadingExcel = ref('')

const qnaReply = ref<AdminCsQna | null>(null)
const qnaReplyContent = ref('')
const submittingQnaReply = ref(false)

const viewCount = computed(() => {
  if (tab.value === 'consult') return consultItems.value.length
  if (tab.value === 'qna') return qnas.value.length
  return reviews.value.length
})

function notify(message: string) {
  toast.value = message
  window.clearTimeout(toastTimer)
  toastTimer = window.setTimeout(() => {
    toast.value = ''
  }, 2400)
}

function formatDate(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString('ko-KR')
}

function consultStatusLabel(row: { status?: string; sellerReplyAllowed?: boolean }) {
  const base = row.status === 'DONE' ? '답변완료' : '답변대기'
  return row.sellerReplyAllowed ? `${base} · 위임` : base
}

function consultStatusBadgeClass(row: { status?: string; sellerReplyAllowed?: boolean }) {
  if (row.status === 'DONE') return 'sui-badge--green'
  if (row.sellerReplyAllowed) return 'sui-badge--blue'
  return 'sui-badge--amber'
}

function setTab(next: CsTab) {
  tab.value = next
  syncQuery()
  void (next === 'consult' ? loadConsult(1) : load())
}

function syncQuery() {
  const query: Record<string, string> = {}
  if (tab.value !== 'consult') query.tab = tab.value
  if (tab.value !== 'consult' && unansweredOnly.value) query.unanswered = '1'
  if (tab.value === 'consult' && consultStatus.value) query.status = consultStatus.value
  if (tab.value === 'consult' && consultChannel.value) query.channel = consultChannel.value
  if (keyword.value.trim()) query.keyword = keyword.value.trim()
  router.replace({ path: '/admin/cs', query })
}

function setConsultChannel(next: string) {
  if (consultChannel.value === next) return
  consultChannel.value = next
  syncQuery()
  void loadConsult(1)
}

async function loadConsult(page = consultPagination.value.page) {
  loading.value = true
  errorMessage.value = ''
  try {
    const result = await fetchAdminConsultList({
      page,
      limit: consultPagination.value.limit,
      keyword: keyword.value,
      status: consultStatus.value,
      channel: consultChannel.value,
    })
    consultItems.value = result.items
    consultPagination.value = result.pagination
    unansweredConsult.value = result.unanswered
    unansweredConsultPortal.value = result.unansweredPortal ?? 0
    unansweredConsultMall.value = result.unansweredMall ?? 0
  } catch (error) {
    consultItems.value = []
    errorMessage.value = error instanceof Error ? error.message : '상담요청을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    const result = await fetchAdminCs({
      tab: tab.value === 'review' ? 'review' : 'qna',
      unanswered: unansweredOnly.value,
      keyword: keyword.value,
    })
    qnas.value = result.qnas
    reviews.value = result.reviews
    unansweredQna.value = result.unansweredQna
    unansweredReview.value = result.unansweredReview
  } catch (error) {
    qnas.value = []
    reviews.value = []
    errorMessage.value = error instanceof Error ? error.message : '문의·후기를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

async function refreshSideCounts() {
  try {
    const [cs, consult] = await Promise.all([
      fetchAdminCs({ tab: 'qna' }),
      fetchAdminConsultList({ page: 1, limit: 1 }),
    ])
    unansweredQna.value = cs.unansweredQna
    unansweredReview.value = cs.unansweredReview
    unansweredConsult.value = consult.unanswered
    unansweredConsultPortal.value = consult.unansweredPortal ?? 0
    unansweredConsultMall.value = consult.unansweredMall ?? 0
  } catch {
    /* ignore */
  }
}

async function openConsultDetail(id: number) {
  try {
    consultDetail.value = await fetchAdminConsultDetail(id)
    replyContent.value = ''
    clearReplyExcel()
    void loadAiSuggestions()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '상담 상세를 불러오지 못했습니다.'
  }
}

async function loadAiSuggestions(force = false) {
  if (!consultDetail.value) return
  if (aiSuggestLoading.value && !force) return

  const seq = ++aiSuggestSeq
  const requestId = consultDetail.value.request.id
  aiSuggestLoading.value = true
  aiSuggestHint.value = ''
  if (force) replySuggestions.value = []

  try {
    const result = await fetchAdminConsultAiReplies(requestId)
    if (seq !== aiSuggestSeq) return
    replySuggestions.value = result.suggestions
    aiSuggestSource.value = result.source
    aiSuggestHint.value =
      result.source === 'ai'
        ? '문의 내용을 분석한 AI 초안입니다. 클릭하면 입력란에 들어갑니다.'
        : result.message || '자동 초안입니다. OpenAI API 키를 설정하면 AI 추천이 활성화됩니다.'
  } catch (error) {
    if (seq !== aiSuggestSeq) return
    replySuggestions.value = ['기능 오류 수정 완료입니다. 이용에 불편을 드려 죄송합니다.']
    aiSuggestSource.value = 'fallback'
    aiSuggestHint.value = error instanceof Error ? error.message : 'AI 추천을 불러오지 못했습니다.'
  } finally {
    if (seq === aiSuggestSeq) aiSuggestLoading.value = false
  }
}

function onReplyExcelChange(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0] || null
  if (!file) {
    replyExcelFile.value = null
    return
  }
  if (!file.name.toLowerCase().endsWith('.xlsx')) {
    errorMessage.value = 'Excel(.xlsx) 파일만 업로드할 수 있습니다.'
    input.value = ''
    return
  }
  if (file.size > 5 * 1024 * 1024) {
    errorMessage.value = '파일 크기는 5MB 이하여야 합니다.'
    input.value = ''
    return
  }
  replyExcelFile.value = file
}

function clearReplyExcel() {
  replyExcelFile.value = null
  if (replyExcelInput.value) replyExcelInput.value.value = ''
}

function applyReplySuggestion(text: string) {
  replyContent.value = text
}

async function onToggleSellerReply(next: boolean) {
  if (!consultDetail.value) return
  if (delegateSaving.value) return
  if (consultDetail.value.request.sellerReplyAllowed === next) return
  /*
   * 관리자가 「판매업체 답변 허용」 을 켜면 이 주문에 실제로 낀 판매업체가
   * 판매관리센터에서 답변할 수 있게 된다. 저장 중에 스위치가 다시 꺼지지
   * 않도록 먼저 화면에 반영하고, 실패하면 되돌린다.
   */
  const reqId = consultDetail.value.request.id
  const prev = consultDetail.value.request.sellerReplyAllowed === true
  consultDetail.value.request.sellerReplyAllowed = next
  delegateSaving.value = true
  errorMessage.value = ''
  try {
    const saved = await setAdminConsultSellerReplyPermission(reqId, next)
    const allowed = saved.sellerReplyAllowed === true
    if (consultDetail.value?.request.id === reqId) {
      consultDetail.value.request.sellerReplyAllowed = allowed
    }
    notify(allowed ? '판매업체에게 답변 권한을 위임했습니다.' : '판매업체 답변 권한을 회수했습니다.')
    await openConsultDetail(reqId)
    await loadConsult()
  } catch (error) {
    if (consultDetail.value?.request.id === reqId) {
      consultDetail.value.request.sellerReplyAllowed = prev
    }
    errorMessage.value = error instanceof Error ? error.message : '위임 상태 변경에 실패했습니다.'
  } finally {
    delegateSaving.value = false
  }
}

async function submitConsultReply() {
  if (!consultDetail.value || !replyContent.value.trim() || submittingReply.value) return
  submittingReply.value = true
  errorMessage.value = ''
  try {
    await createAdminConsultResponse(
      consultDetail.value.request.id,
      replyContent.value.trim(),
      replyExcelFile.value,
    )
    notify('답변이 등록되었습니다.')
    await openConsultDetail(consultDetail.value.request.id)
    await loadConsult()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '답변 등록에 실패했습니다.'
  } finally {
    submittingReply.value = false
  }
}

async function onDownloadConsultExcel() {
  if (!consultDetail.value) return
  downloadingExcel.value = 'req'
  try {
    await downloadAdminConsultExcel(
      consultDetail.value.request.id,
      consultDetail.value.request.excelName || `consult-${consultDetail.value.request.id}.xlsx`,
    )
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : 'Excel 다운로드에 실패했습니다.'
  } finally {
    downloadingExcel.value = ''
  }
}

async function onDownloadConsultResponseExcel(response: AdminConsultResponse) {
  if (!consultDetail.value) return
  downloadingExcel.value = `res-${response.id}`
  try {
    await downloadAdminConsultResponseExcel(
      consultDetail.value.request.id,
      response.id,
      response.excelName || `consult-response-${response.id}.xlsx`,
    )
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : 'Excel 다운로드에 실패했습니다.'
  } finally {
    downloadingExcel.value = ''
  }
}

function openQnaReply(row: AdminCsQna) {
  qnaReply.value = row
  qnaReplyContent.value = ''
  errorMessage.value = ''
}

function closeQnaReply() {
  qnaReply.value = null
  qnaReplyContent.value = ''
}

async function submitQnaReply() {
  if (!qnaReply.value || !qnaReplyContent.value.trim() || submittingQnaReply.value) return
  submittingQnaReply.value = true
  errorMessage.value = ''
  try {
    await answerAdminCsQna(qnaReply.value.idx, qnaReplyContent.value.trim())
    notify('문의 답변을 등록했습니다.')
    closeQnaReply()
    await load()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '문의 답변 등록에 실패했습니다.'
  } finally {
    submittingQnaReply.value = false
  }
}

async function onHide(kind: 'qna' | 'review', idx: number, id: string) {
  if (working.value) return
  if (!window.confirm('몰에서 숨길까요? 판매업체·구매 기관 목록에서도 보이지 않습니다.')) return
  working.value = id
  try {
    await deleteAdminCsItem(kind, idx)
    notify('숨김 처리했습니다.')
    await load()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '숨김 처리에 실패했습니다.'
  } finally {
    working.value = ''
  }
}

watch(unansweredOnly, () => {
  if (tab.value !== 'consult') syncQuery()
})

watch(consultStatus, () => {
  if (tab.value === 'consult') syncQuery()
})

onMounted(async () => {
  await refreshSideCounts()
  if (tab.value === 'consult') await loadConsult(1)
  else await load()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", {
        class: _normalizeClass(["sui-card acs__kpi", { 'is-alert': unansweredQna.value > 0 }])
      }, [
        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "acs__kpi-label" }, "미답변 상품문의", -1)),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(unansweredQna.value), 1),
          _cache[23] || (_cache[23] = _createElementVNode("em", null, "건", -1))
        ])
      ], 2),
      _createElementVNode("article", {
        class: _normalizeClass(["sui-card acs__kpi", { 'is-alert': unansweredReview.value > 0 }])
      }, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "acs__kpi-label" }, "미답변 후기", -1)),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(unansweredReview.value), 1),
          _cache[25] || (_cache[25] = _createElementVNode("em", null, "건", -1))
        ])
      ], 2),
      _createElementVNode("article", {
        class: _normalizeClass(["sui-card acs__kpi", { 'is-alert': unansweredConsult.value > 0 }])
      }, [
        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "acs__kpi-label" }, "미답변 1:1 상담", -1)),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(unansweredConsult.value), 1),
          _cache[27] || (_cache[27] = _createElementVNode("em", null, "건", -1))
        ])
      ], 2),
      _createElementVNode("article", _hoisted_6, [
        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "acs__kpi-label" }, "조회 건수", -1)),
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode(_toDisplayString(viewCount.value), 1),
          _cache[29] || (_cache[29] = _createElementVNode("em", null, "건", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["sui-tab", { 'is-active': tab.value === 'consult' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab('consult')))
        }, [
          _cache[31] || (_cache[31] = _createTextVNode(" 1:1 상담 ", -1)),
          _createElementVNode("em", null, _toDisplayString(unansweredConsult.value), 1)
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["sui-tab", { 'is-active': tab.value === 'qna' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab('qna')))
        }, [
          _cache[32] || (_cache[32] = _createTextVNode(" 상품 문의 ", -1)),
          _createElementVNode("em", null, _toDisplayString(unansweredQna.value), 1)
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["sui-tab", { 'is-active': tab.value === 'review' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setTab('review')))
        }, [
          _cache[33] || (_cache[33] = _createTextVNode(" 구매후기 ", -1)),
          _createElementVNode("em", null, _toDisplayString(unansweredReview.value), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (tab.value === 'consult')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  role: "tab",
                  class: _normalizeClass(["acs__channel-tab", { 'is-active': consultChannel.value === '' }]),
                  "aria-selected": consultChannel.value === '',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setConsultChannel('')))
                }, " 전체 ", 10, _hoisted_12),
                _createElementVNode("button", {
                  type: "button",
                  role: "tab",
                  class: _normalizeClass(["acs__channel-tab", { 'is-active': consultChannel.value === 'PORTAL' }]),
                  "aria-selected": consultChannel.value === 'PORTAL',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setConsultChannel('PORTAL')))
                }, [
                  _cache[34] || (_cache[34] = _createTextVNode(" 포털 상담 ", -1)),
                  (unansweredConsultPortal.value)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_14, "(" + _toDisplayString(unansweredConsultPortal.value) + ")", 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  role: "tab",
                  class: _normalizeClass(["acs__channel-tab", { 'is-active': consultChannel.value === 'MALL' }]),
                  "aria-selected": consultChannel.value === 'MALL',
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (setConsultChannel('MALL')))
                }, [
                  _cache[35] || (_cache[35] = _createTextVNode(" 몰 문의 ", -1)),
                  (unansweredConsultMall.value)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_16, "(" + _toDisplayString(unansweredConsultMall.value) + ")", 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_15)
              ]),
              _createElementVNode("label", _hoisted_17, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "acs__sr" }, "상태", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((consultStatus).value = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (loadConsult(1)))
                }, [...(_cache[36] || (_cache[36] = [
                  _createElementVNode("option", { value: "" }, "전체", -1),
                  _createElementVNode("option", { value: "WAIT" }, "답변대기", -1),
                  _createElementVNode("option", { value: "DONE" }, "답변완료", -1),
                  _createElementVNode("option", { value: "DELEGATED" }, "판매자 위임", -1)
                ]))], 544), [
                  [_vModelSelect, consultStatus.value]
                ])
              ]),
              _createElementVNode("label", _hoisted_18, [
                _createVNode(AppIcon, {
                  icon: "mdi-magnify",
                  size: 17
                }),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((keyword).value = $event)),
                  type: "search",
                  placeholder: "제목 · ID · 기관명 · 기관기호 · 주문번호",
                  onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (loadConsult(1)), ["enter"]))
                }, null, 544), [
                  [
                    _vModelText,
                    keyword.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("label", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((unansweredOnly).value = $event)),
                  type: "checkbox",
                  onChange: load
                }, null, 544), [
                  [_vModelCheckbox, unansweredOnly.value]
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("span", null, "미답변만", -1))
              ]),
              _createElementVNode("label", _hoisted_20, [
                _createVNode(AppIcon, {
                  icon: "mdi-magnify",
                  size: 17
                }),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((keyword).value = $event)),
                  type: "search",
                  placeholder: "상품 · 업체 · 기관 · 주문번호 · 내용 검색",
                  onKeydown: _withKeys(load, ["enter"])
                }, null, 544), [
                  [
                    _vModelText,
                    keyword.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ], 64)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (tab.value === 'consult' ? loadConsult(1) : load()))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 16
          }),
          _cache[39] || (_cache[39] = _createTextVNode(" 검색 ", -1))
        ], 8, _hoisted_21),
        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: _cache[13] || (_cache[13] = ($event: any) => (tab.value === 'consult' ? loadConsult() : load()))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[40] || (_cache[40] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_22)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      (toast.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
            _createVNode(AppIcon, {
              icon: "mdi-check-circle",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(toast.value), 1)
          ]))
        : _createCommentVNode("", true),
      (tab.value === 'consult' && consultItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "상태"),
                  _createElementVNode("th", null, "분류"),
                  _createElementVNode("th", null, "작성자 ID"),
                  _createElementVNode("th", null, "제목"),
                  _createElementVNode("th", null, "관련 주문"),
                  _createElementVNode("th", null, "기관"),
                  _createElementVNode("th", null, "연락처"),
                  _createElementVNode("th", { class: "is-center" }, "처리")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consultItems.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id
                  }, [
                    _createElementVNode("td", _hoisted_27, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", consultStatusBadgeClass(row)]),
                        title: 
                    row.sellerReplyAllowed
                      ? '관리자가 판매업체에게 답변 권한을 위임한 상담'
                      : undefined
                  
                      }, _toDisplayString(consultStatusLabel(row)), 11, _hoisted_28),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(formatDate(row.createdAt)), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(row.kind || '일반상담'), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(row.authorId), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(row.title), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["acs__channel-badge", row.channel === 'MALL' ? 'is-mall' : 'is-portal'])
                      }, _toDisplayString(row.channel === 'MALL' ? '몰' : '포털'), 3),
                      (row.isTest)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "테스트"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      (row.orderCode)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "acs__order-badge",
                            to: { path: '/admin/orders', query: { keyword: row.orderCode } },
                            title: `${row.orderCode} 주문 상세로 이동`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(AppIcon, {
                                icon: "mdi-receipt-text-outline",
                                size: 14
                              }),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(row.orderCode), 1),
                              _createVNode(AppIcon, {
                                icon: "mdi-chevron-right",
                                size: 14
                              })
                            ]),
                            _: 2
                          }, 1032, ["to", "title"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _createVNode(AppIcon, {
                              icon: "mdi-help-circle-outline",
                              size: 14
                            }),
                            _cache[42] || (_cache[42] = _createTextVNode(" 일반 상담 ", -1))
                          ]))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(row.orgName || '-'), 1),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(row.orgCode || '-'), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(row.contactPhone || '-'), 1),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sui-btn sui-btn--sm",
                        onClick: ($event: any) => (openConsultDetail(row.id))
                      }, " 상세·답변 ", 8, _hoisted_37)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (consultPagination.value.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn sui-btn--sm",
                    disabled: consultPagination.value.page <= 1 || loading.value,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (loadConsult(consultPagination.value.page - 1)))
                  }, " 이전 ", 8, _hoisted_39),
                  _createElementVNode("span", null, _toDisplayString(consultPagination.value.page) + " / " + _toDisplayString(consultPagination.value.totalPages), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn sui-btn--sm",
                    disabled: consultPagination.value.page >= consultPagination.value.totalPages || loading.value,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (loadConsult(consultPagination.value.page + 1)))
                  }, " 다음 ", 8, _hoisted_40)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (tab.value === 'qna' && qnas.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("table", _hoisted_42, [
                _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "상태"),
                    _createElementVNode("th", null, "상품 · 판매업체"),
                    _createElementVNode("th", null, "기관"),
                    _createElementVNode("th", null, "관련 주문"),
                    _createElementVNode("th", null, "문의"),
                    _createElementVNode("th", { class: "is-center" }, "처리")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qnas.value, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["sui-badge", row.answer ? 'sui-badge--green' : 'sui-badge--amber'])
                        }, _toDisplayString(row.answer ? '답변완료' : '미답변'), 3),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(row.date), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(row.productName || row.productCode), 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(row.storeName || '-'), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(row.org), 1),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(row.author), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (row.orderCode)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "acs__order-badge",
                              to: { path: '/admin/orders', query: { keyword: row.orderCode } },
                              title: `${row.orderCode} 주문 상세로 이동`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  icon: "mdi-receipt-text-outline",
                                  size: 14
                                }),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(row.orderCode), 1),
                                _createVNode(AppIcon, {
                                  icon: "mdi-chevron-right",
                                  size: 14
                                })
                              ]),
                              _: 2
                            }, 1032, ["to", "title"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_48, [
                              _createVNode(AppIcon, {
                                icon: "mdi-help-circle-outline",
                                size: 14
                              }),
                              _cache[44] || (_cache[44] = _createTextVNode(" 일반 문의 ", -1))
                            ])),
                        (row.orderAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(String(row.orderAt).slice(0, 10)), 1))
                          : _createCommentVNode("", true),
                        (row.orderSummary)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              class: "sui-table__sub acs__order-summary",
                              title: row.orderSummary
                            }, _toDisplayString(row.orderSummary), 9, _hoisted_50))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(row.question), 1),
                        (row.answer)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, "A. " + _toDisplayString(row.answer), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_53, [
                        (!row.answer)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "sui-btn sui-btn--sm sui-btn--primary",
                              onClick: ($event: any) => (openQnaReply(row))
                            }, " 답변 ", 8, _hoisted_54))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          class: "sui-btn sui-btn--sm",
                          href: `/mall/${encodeURIComponent(row.productCode)}`,
                          target: "_blank",
                          rel: "noopener"
                        }, " 상품 ", 8, _hoisted_55),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sui-btn sui-btn--sm",
                          disabled: working.value === row.id,
                          onClick: ($event: any) => (onHide('qna', row.idx, row.id))
                        }, " 숨김 ", 8, _hoisted_56)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (tab.value === 'review' && reviews.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("table", _hoisted_58, [
                  _cache[47] || (_cache[47] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "상태"),
                      _createElementVNode("th", null, "상품 · 판매업체"),
                      _createElementVNode("th", null, "기관 · 별점"),
                      _createElementVNode("th", null, "관련 주문"),
                      _createElementVNode("th", null, "내용"),
                      _createElementVNode("th", { class: "is-center" }, "처리")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["sui-badge", row.reply ? 'sui-badge--green' : 'sui-badge--amber'])
                          }, _toDisplayString(row.reply ? '답변완료' : '미답변'), 3),
                          _createElementVNode("span", _hoisted_59, _toDisplayString(row.date), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(row.productName || row.productCode), 1),
                          _createElementVNode("span", _hoisted_61, _toDisplayString(row.storeName || '-'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", null, _toDisplayString(row.org), 1),
                          _createElementVNode("span", _hoisted_62, "★ " + _toDisplayString(row.rating) + " · " + _toDisplayString(row.author), 1)
                        ]),
                        _createElementVNode("td", null, [
                          (row.orderCode)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "acs__order-badge",
                                to: { path: '/admin/orders', query: { keyword: row.orderCode } },
                                title: `${row.orderCode} 주문 상세로 이동`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(AppIcon, {
                                    icon: "mdi-receipt-text-outline",
                                    size: 14
                                  }),
                                  _createElementVNode("span", _hoisted_63, _toDisplayString(row.orderCode), 1),
                                  _createVNode(AppIcon, {
                                    icon: "mdi-chevron-right",
                                    size: 14
                                  })
                                ]),
                                _: 2
                              }, 1032, ["to", "title"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_64, [
                                _createVNode(AppIcon, {
                                  icon: "mdi-help-circle-outline",
                                  size: 14
                                }),
                                _cache[46] || (_cache[46] = _createTextVNode(" 연결된 주문 없음 ", -1))
                              ])),
                          (row.orderAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(String(row.orderAt).slice(0, 10)), 1))
                            : _createCommentVNode("", true),
                          (row.orderSummary)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "sui-table__sub acs__order-summary",
                                title: row.orderSummary
                              }, _toDisplayString(row.orderSummary), 9, _hoisted_66))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_67, _toDisplayString(row.content), 1),
                          (row.reply)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "A. " + _toDisplayString(row.reply), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_69, [
                          _createElementVNode("a", {
                            class: "sui-btn sui-btn--sm",
                            href: `/mall/${encodeURIComponent(row.productCode)}`,
                            target: "_blank",
                            rel: "noopener"
                          }, " 상품 ", 8, _hoisted_70),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sui-btn sui-btn--sm",
                            disabled: working.value === row.id,
                            onClick: ($event: any) => (onHide('review', row.idx, row.id))
                          }, " 숨김 ", 8, _hoisted_71)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createVNode(AppIcon, {
                  icon: "mdi-message-text-outline",
                  size: 32
                }),
                _createElementVNode("p", null, _toDisplayString(loading.value ? '불러오는 중입니다…' : '조건에 맞는 항목이 없습니다.'), 1)
              ]))
    ]),
    (consultDetail.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "acs__modal",
          "data-tour": "admin-cs-consult-detail",
          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (consultDetail.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("header", _hoisted_74, [
              _createElementVNode("h2", null, [
                _cache[48] || (_cache[48] = _createTextVNode(" 상담요청 상세 ", -1)),
                _createElementVNode("em", {
                  class: _normalizeClass(
                consultDetail.value.request.status === 'DONE'
                  ? 'is-done'
                  : consultDetail.value.request.sellerReplyAllowed
                    ? 'is-delegated'
                    : 'is-wait'
              )
                }, _toDisplayString(consultStatusLabel(consultDetail.value.request)), 3)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "acs__close",
                "aria-label": "닫기",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (consultDetail.value = null))
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("dl", _hoisted_76, [
                _createElementVNode("div", null, [
                  _cache[49] || (_cache[49] = _createElementVNode("dt", null, "분류", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.kind || '일반상담'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[50] || (_cache[50] = _createElementVNode("dt", null, "제목", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.title), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[51] || (_cache[51] = _createElementVNode("dt", null, "작성자 ID", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.authorId), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[52] || (_cache[52] = _createElementVNode("dt", null, "채널", -1)),
                  _createElementVNode("dd", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["acs__channel-badge", consultDetail.value.request.channel === 'MALL' ? 'is-mall' : 'is-portal'])
                    }, _toDisplayString(consultDetail.value.request.channel === 'MALL' ? '함우리몰' : '포털'), 3),
                    (consultDetail.value.request.isTest)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, "테스트"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[53] || (_cache[53] = _createElementVNode("dt", null, "기관명", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.orgName || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[54] || (_cache[54] = _createElementVNode("dt", null, "기관기호", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.orgCode || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[55] || (_cache[55] = _createElementVNode("dt", null, "관련 주문", -1)),
                  _createElementVNode("dd", null, [
                    (consultDetail.value.request.orderCode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "acs__order-badge",
                          to: { path: '/admin/orders', query: { keyword: consultDetail.value.request.orderCode } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(AppIcon, {
                              icon: "mdi-receipt-text-outline",
                              size: 14
                            }),
                            _createElementVNode("span", _hoisted_78, _toDisplayString(consultDetail.value.request.orderCode), 1),
                            _createVNode(AppIcon, {
                              icon: "mdi-chevron-right",
                              size: 14
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(consultDetail.value.request.channel === 'MALL' ? '주문 없는 몰 문의' : '포털 상담'), 1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[56] || (_cache[56] = _createElementVNode("dt", null, "연락처", -1)),
                  _createElementVNode("dd", null, _toDisplayString(consultDetail.value.request.contactPhone || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[57] || (_cache[57] = _createElementVNode("dt", null, "등록일", -1)),
                  _createElementVNode("dd", null, _toDisplayString(formatDate(consultDetail.value.request.createdAt)), 1)
                ])
              ]),
              _createElementVNode("section", _hoisted_80, [
                _cache[58] || (_cache[58] = _createElementVNode("h3", null, "상담 내용", -1)),
                _createElementVNode("p", _hoisted_81, _toDisplayString(consultDetail.value.request.content), 1)
              ]),
              (consultDetail.value.request.hasExcel)
                ? (_openBlock(), _createElementBlock("section", _hoisted_82, [
                    _cache[59] || (_cache[59] = _createElementVNode("h3", null, "첨부 Excel", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn sui-btn--sm",
                      disabled: downloadingExcel.value === 'req',
                      onClick: onDownloadConsultExcel
                    }, _toDisplayString(consultDetail.value.request.excelName || 'Excel 다운로드'), 9, _hoisted_83)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_84, [
                _cache[61] || (_cache[61] = _createElementVNode("h3", null, "판매업체에게 답변 위임", -1)),
                _createElementVNode("p", _hoisted_85, _toDisplayString(consultDetail.value.request.orderCode
                  ? '위임을 켜면 이 주문의 판매업체가 판매관리센터에서 직접 답변을 남길 수 있습니다. 언제든 다시 회수할 수 있습니다.'
                  : '관련 주문이 없는 일반 상담은 위임할 수 없습니다. 관리자만 답변합니다.'), 1),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: consultDetail.value.request.sellerReplyAllowed === true,
                      disabled: 
                    delegateSaving.value ||
                    !consultDetail.value.request.orderCode
                  ,
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (onToggleSellerReply(($event.target as HTMLInputElement).checked)))
                    }, null, 40, _hoisted_88),
                    _cache[60] || (_cache[60] = _createElementVNode("span", { class: "acs__switch-track" }, [
                      _createElementVNode("span", { class: "acs__switch-thumb" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_89, _toDisplayString(consultDetail.value.request.sellerReplyAllowed
                      ? '판매업체 답변 허용'
                      : '판매업체 답변 잠금'), 1)
                  ]),
                  (delegateSaving.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, "저장 중…"))
                    : (consultDetail.value.request.sellerReplyAllowed && consultDetail.value.request.delegatedAt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                          _createTextVNode(" 위임: " + _toDisplayString(formatDate(consultDetail.value.request.delegatedAt)) + " ", 1),
                          (consultDetail.value.request.delegatedBy)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(consultDetail.value.request.delegatedBy), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]),
              (consultDetail.value.responses.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_92, [
                    _cache[62] || (_cache[62] = _createElementVNode("h3", null, "등록된 답변", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consultDetail.value.responses, (response) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: response.id,
                        class: _normalizeClass(["acs__reply-card", { 'is-seller': response.role === 'SELLER' }])
                      }, [
                        _createElementVNode("header", null, [
                          _createElementVNode("strong", null, _toDisplayString(response.byName || (response.role === 'SELLER' ? '판매업체' : '관리자')), 1),
                          _createElementVNode("em", {
                            class: _normalizeClass(["acs__reply-role", response.role === 'SELLER' ? 'is-seller' : 'is-admin'])
                          }, _toDisplayString(response.role === 'SELLER' ? '판매자' : '관리자'), 3),
                          _createElementVNode("time", null, _toDisplayString(formatDate(response.createdAt)), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(response.content), 1),
                        (response.hasExcel)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "sui-btn sui-btn--sm",
                              disabled: downloadingExcel.value === `res-${response.id}`,
                              onClick: ($event: any) => (onDownloadConsultResponseExcel(response))
                            }, _toDisplayString(response.excelName || 'Excel 다운로드'), 9, _hoisted_93))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_94, [
                _cache[65] || (_cache[65] = _createElementVNode("h3", null, "답변 작성", -1)),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("span", _hoisted_97, _toDisplayString(aiSuggestSource.value === 'ai'
                      ? 'AI 답변 추천'
                      : aiSuggestLoading.value
                        ? 'AI 분석 중'
                        : '답변 추천'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn sui-btn--sm",
                      disabled: aiSuggestLoading.value || !consultDetail.value,
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (loadAiSuggestions(true)))
                    }, _toDisplayString(aiSuggestLoading.value ? '생성 중…' : '다시 생성'), 9, _hoisted_98)
                  ]),
                  (aiSuggestHint.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(aiSuggestHint.value), 1))
                    : _createCommentVNode("", true),
                  (aiSuggestLoading.value && !replySuggestions.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_100, " 문의 내용을 분석해 답변 초안을 만드는 중입니다… "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replySuggestions.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: index,
                      type: "button",
                      class: "acs__suggest-btn",
                      onClick: ($event: any) => (applyReplySuggestion(item))
                    }, _toDisplayString(item), 9, _hoisted_101))
                  }), 128))
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((replyContent).value = $event)),
                  class: "acs__textarea",
                  rows: "6",
                  placeholder: "상담 답변 내용을 입력해 주세요."
                }, null, 512), [
                  [_vModelText, replyContent.value]
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _cache[63] || (_cache[63] = _createElementVNode("span", null, "Excel 첨부 (선택)", -1)),
                  _createElementVNode("input", {
                    ref_key: "replyExcelInput",
                    ref: replyExcelInput,
                    type: "file",
                    accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    onChange: onReplyExcelChange
                  }, null, 544),
                  _cache[64] || (_cache[64] = _createElementVNode("p", { class: "acs__file-hint" }, ".xlsx, 5MB 이하 · 매크로 포함 파일 불가", -1)),
                  (replyExcelFile.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_103, [
                        _createTextVNode(_toDisplayString(replyExcelFile.value.name) + " ", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sui-btn sui-btn--sm",
                          onClick: clearReplyExcel
                        }, "취소")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_104, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (consultDetail.value = null))
              }, "닫기"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: submittingReply.value || !replyContent.value.trim(),
                onClick: submitConsultReply
              }, " 답변 등록 ", 8, _hoisted_105)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (qnaReply.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "acs__modal",
          "data-tour": "admin-cs-qna-reply",
          onClick: _withModifiers(closeQnaReply, ["self"])
        }, [
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("header", _hoisted_107, [
              _cache[66] || (_cache[66] = _createElementVNode("h2", null, [
                _createTextVNode(" 상품문의 답변 "),
                _createElementVNode("em", { class: "is-wait" }, "미답변")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "acs__close",
                "aria-label": "닫기",
                onClick: closeQnaReply
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("dl", _hoisted_109, [
                _createElementVNode("div", null, [
                  _cache[67] || (_cache[67] = _createElementVNode("dt", null, "상품", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.productName || qnaReply.value.productCode), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[68] || (_cache[68] = _createElementVNode("dt", null, "판매업체", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.storeName || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[69] || (_cache[69] = _createElementVNode("dt", null, "기관", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.org || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[70] || (_cache[70] = _createElementVNode("dt", null, "작성자", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.author || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[71] || (_cache[71] = _createElementVNode("dt", null, "관련 주문", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.orderCode || '일반 문의'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[72] || (_cache[72] = _createElementVNode("dt", null, "등록일", -1)),
                  _createElementVNode("dd", null, _toDisplayString(qnaReply.value.date || '-'), 1)
                ])
              ]),
              _createElementVNode("section", _hoisted_110, [
                _cache[73] || (_cache[73] = _createElementVNode("h3", null, "문의 내용", -1)),
                _createElementVNode("p", _hoisted_111, _toDisplayString(qnaReply.value.question), 1)
              ]),
              _createElementVNode("section", _hoisted_112, [
                _cache[74] || (_cache[74] = _createElementVNode("h3", null, "답변 작성", -1)),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_113, [
                      _createVNode(AppIcon, {
                        icon: "mdi-alert-outline",
                        size: 16
                      }),
                      _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((qnaReplyContent).value = $event)),
                  class: "acs__textarea",
                  rows: "6",
                  placeholder: "판매업체를 대신해 답변할 내용을 입력해 주세요."
                }, null, 512), [
                  [_vModelText, qnaReplyContent.value]
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_114, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeQnaReply
              }, "닫기"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: submittingQnaReply.value || !qnaReplyContent.value.trim(),
                onClick: submitQnaReply
              }, _toDisplayString(submittingQnaReply.value ? '등록 중…' : '답변 등록'), 9, _hoisted_115)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})